package org.hs_soft.runmynesto.data.api_datasource.options.export

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info.CashRegisterGlobalModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.UpdateCashReigsterGloabalRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class UpdateCashRegisterGlobalRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
) : UpdateCashReigsterGloabalRepository {

    override suspend fun updateCashRegisterGlobal(title: String, value: Any):
            CashRegisterGlobalModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                mutation updateAppConfig(${'$'}fields: AppConfigInput) {
                  ${ApiUtils.Field.cashAssist} {
                    ${ApiUtils.Field.updateAppConfig}(fields: ${'$'}fields) {
                      ...apaleo
                      ${ApiUtils.Field.__typename}
                    }
                    ${ApiUtils.Field.__typename}
                  }
                }
                
                fragment apaleo on AppConfig {
                  ${ApiUtils.Field.cashRegisterGlobal} {
                    ${ApiUtils.Field.apaleaoClientId}
                    ${ApiUtils.Field.apaleaoClientSecret}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.__typename}
                }
            """.trimIndent())
            
            putJsonObject("variables") {
                putJsonObject("fields") {
                    putJsonObject("cashRegisterGlobal") {
                        when(value){
                            is String -> put(title,value as String)
                            is Boolean->put(title,value as Boolean)
                        }
                    }
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
} 